// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg[data-v-23e29c5d] {\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n}\n.embed-preview[data-v-23e29c5d] {\n  border: 1px solid #ccc;\n  background: white;\n  padding: 40px;\n  margin-top: 20px;\n  min-height: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
